"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  name: "Solid Dew",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/Screenshot 2026-05-26 alle 17.28.44.png"
}, {
  name: "Associazione Agricoltura Sostenibile",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/Screenshot 2026-05-26 alle 17.34.28.png"
}, {
  name: "EcoCert Italia",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/partner_logo_eco_cert.png"
}, {
  name: "WaterSave Technologies",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/partner_logo_water_tech.png"
}, {
  name: "BioAgri Italia",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680532/img/partner_logo_bio_italia.png"
}];
export default function Logos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="logos" className="bg-background py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-6 md:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center text-xs md:text-sm font-semibold tracking-widest text-muted-foreground uppercase mb-12 md:mb-16 font-default">
          Partner Strategici e Associazioni
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-20 lg:gap-28">
          {partners.map((partner, i) => <div key={i} data-index={i} className="flex items-center justify-center group">
              <img src={partner.src} alt={`Logo ${partner.name}`} loading="lazy" className="object-contain grayscale opacity-40 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 ease-in-out !w-[200px] !h-[73px]" />
            </div>)}
        </div>
      </div>
    </section>;
}